import React from 'react';
import styled from 'styled-components';

const CTA = styled.div`
  margin-top: 20px;
  a {
    background: #d40f7d;
    border: none;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    color: #ffffff;
    -webkit-text-stroke-width: 1;
    -webkit-text-stroke-color: #000000;
    font-family: 'OCRoboto';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 115%;
    text-decoration: none;
  }
  @media (min-width: 760px) {
    a {
      font-size: 16px;
    }
  }
`;

export default ({ url }) => (
  <CTA>
    <a
      href={url}
      target="_blank"
      title="Download Color Selection Checklist"
      rel="noreferrer"
    >
      <i className="fa fa-file-pdf-o" /> &nbsp; Color Selection Checklist
    </a>
  </CTA>
);
